import styled from 'styled-components';
import { lighten } from 'polished';

const Button = styled.button`
  font-family: ${props => props.theme.fontFamily};
  font-weight: ${props => props.theme.fontBold};
  background-color: ${props =>
    props.secondary
      ? props.theme.buttons.secondary.backgroundColor
      : props.theme.buttons.primary.backgroundColor};
  color: ${props => props.theme.colors.white};
  border: ${props => props.theme.buttons.border};
  text-transform: ${props => props.theme.buttons.textUpperCase};
  padding: ${props => props.theme.buttons.padding};
  display: ${props =>
    props.block ? props.theme.buttons.block : props.theme.buttons.inline};
  width: ${props => (props.block ? '100%' : 'auto')};
  cursor: ${props => props.theme.buttons.cursor};

  &:hover {
    background-color: ${props =>
      lighten(
        0.05,
        props.secondary
          ? props.theme.buttons.secondary.backgroundColor
          : props.theme.buttons.primary.backgroundColor
      )};
  }

  &[disabled] {
    background-color: ${props => props.theme.colors.darkGrey}
    cursor: auto;
  }
`;

export default Button;
